import { jsx as _jsx } from "react/jsx-runtime";
import diamondBlueUrl from '../../../assets/gems/diamond_blue.svg?inline';
export function DiamondBlue({ ...props }) {
    return _jsx("img", { ...props, src: diamondBlueUrl, alt: 'DiamondBlueImage' });
}
